import React from 'react';
import { Box } from '@10d/tend-ui-grid';
import { UNSTABLE_useControllableStateV2, useCallbackRef } from '@10d/tend-ui-hooks';
import cn from 'classnames';
import { UNSTABLE_InputNumber } from '../InputNumber/InputNumber.js';

const DEFAULT_VALUE = [null, null];
const RangeInput = ({ size, rootClassName, disabled, onChange, placeholder, value, defaultValue, allowClear, before, after, }) => {
    const [__value = DEFAULT_VALUE, __setValue] = UNSTABLE_useControllableStateV2({
        value,
        defaultValue,
        onChange,
    });
    const handleFromChange = useCallbackRef(payload => {
        __setValue(([, to] = DEFAULT_VALUE) => [payload, to]);
    });
    const handleToChange = useCallbackRef(payload => {
        __setValue(([from] = DEFAULT_VALUE) => [from, payload]);
    });
    return (React.createElement(Box, { "$width": '100%', "data-testid": 'tend-ui-range-input', "$display": 'flex', "$alignItems": 'center', "$gap": 10, className: cn(['tend-ui-range-input-root', rootClassName]) },
        React.createElement(UNSTABLE_InputNumber, { "data-testid": 'tend-ui-range-input-from', value: __value[0], disabled: disabled, placeholder: placeholder === null || placeholder === void 0 ? void 0 : placeholder.at(0), onChange: handleFromChange, allowClear: allowClear, size: size, before: before === null || before === void 0 ? void 0 : before.at(0), after: after === null || after === void 0 ? void 0 : after.at(0) }),
        React.createElement(Box, { as: 'span', className: 'tend-ui-range-input-separator' }, "\u2014"),
        React.createElement(UNSTABLE_InputNumber, { "data-testid": 'tend-ui-range-input-to', value: __value[1], disabled: disabled, placeholder: placeholder === null || placeholder === void 0 ? void 0 : placeholder.at(1), onChange: handleToChange, allowClear: allowClear, size: size, before: before === null || before === void 0 ? void 0 : before.at(1), after: after === null || after === void 0 ? void 0 : after.at(1) })));
};
RangeInput.displayName = 'RangeInput';

export { RangeInput };
//# sourceMappingURL=RangeInput.js.map
